module.exports = __webpack_public_path__ + "img/sber_0027.4e174f00.png";